var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaitGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.391 207.708C228.052 200.379 230.194 192.843 235.187 187.313L319.361 94.0895C321.79 91.3993 324.959 90.1499 328.092 90.1213H219.268C216.077 90.104 212.836 91.3493 210.361 94.0898L126.187 187.313C121.194 192.843 119.052 200.379 120.391 207.708L132.86 276H241.86L229.391 207.708Z",
    fill: "#495057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M254 288L139.5 288C148.613 288 156 296.507 156 307C156 309.858 155.452 312.569 154.47 315H268.47C269.452 312.569 270 309.858 270 307C270 296.699 262.881 288.313 254 288.009V288Z",
    fill: "#495057"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M268.04 317.213L266.923 318.231H163.745C171.388 321.091 176.846 328.622 176.846 337.462C176.846 346.64 170.963 354.406 162.858 357H276.857C284.962 354.406 290.846 346.64 290.846 337.462C290.846 326.161 281.926 317 270.923 317C269.944 317 268.982 317.073 268.04 317.213Z",
    fill: "#495057"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M275.366 360.231H161.366C164.807 363.624 167 368.756 167 374.5C167 381.703 163.551 387.944 158.517 391H272.517C277.551 387.944 281 381.703 281 374.5C281 368.756 278.807 363.624 275.366 360.231Z",
    fill: "#495057"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M264.685 401H155.684L157.697 412.024C158.806 418.098 163.938 421.744 169.268 421.876C169.467 421.881 169.667 421.881 169.867 421.876H278.268C272.938 421.744 267.806 418.097 266.697 412.024L264.685 401Z",
    fill: "#495057"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 252C40 247.582 42.5253 244 45.6405 244L115 244L119.5 268L45.6405 268C42.5253 268 40 264.418 40 260L40 252Z",
    fill: "#495057"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M252.919 187.313C247.926 192.843 245.784 200.378 247.123 207.707L259.599 276.038C259.986 276.012 260.377 275.999 260.769 275.999C272.07 275.999 281.231 286.848 281.231 300.23C281.231 302.636 280.935 304.96 280.383 307.154C290.721 306.393 300.613 315.183 303.61 328.657C306.636 342.258 301.616 356.045 292.202 361.626C294.585 365.75 296 370.906 296 376.499C296 387.848 290.174 397.394 282.267 400.178L284.429 412.023C286.218 421.818 298.468 425.3 305.141 417.91L389.315 324.686C394.308 319.156 396.45 311.621 395.111 304.291L390.311 277.999H322C315.373 277.999 310 268.15 310 255.999C310 243.849 315.373 233.999 322 233.999H382.277L357.805 99.9753C356.016 90.1808 343.766 86.699 337.093 94.0888L252.919 187.313Z",
    fill: "#495057"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.106 244C322.106 244 318.586 247.8 318.586 256C318.586 264.2 322.106 268 322.106 268L466.69 268C469.796 268 472.315 264.418 472.315 260L472.315 252C472.315 247.582 469.796 244 466.69 244L322.106 244Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaitGrey);
export default __webpack_public_path__ + "static/media/BaitGrey.9d6ec076b2c73224acb00d3eaa09e90f.svg";
export { ForwardRef as ReactComponent };